import angular from 'angular';
import 'angular-ui-router';
import 'ng-file-upload/dist/ng-file-upload';
import 'angular-modal-service';
import Filters from '../../filters/filters';
import template from './videoCreativesForm.jade';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import FiltersModule from '../../filters/filters';

export class VideoCreativesFormController {
  /* @ngInject */
  constructor($scope, $element, $timeout, $window, currentGame, $filter, ModalService, Upload, $stateParams, GamesResource, setProgressBar, notify, $sce) {
    this.$scope = $scope;
    this.$sce = $sce;
    this.$window = $window;
    this.ModalService = ModalService;
    this.currentGame = currentGame;
    this.GamesResource = GamesResource;
    this.$stateParams = $stateParams;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.Upload = Upload;
    this.setProgressBar = setProgressBar;
    this.notify = notify;
    this.statusOptions =	[
      {name: 'active', value: true},
      {name: 'inactive', value: false}
    ];
    this.validFileTypes = [ 'image/png',
      'image/jpeg',
      'image/pjpeg',
      'image/gif'
    ];

    this.isEditingCompanionAds = false;
    this.isCompanionAdsLoaded = false;
    this.allowedCompanionAdSizes = [
      '1024x768',
      '768x1024',
      '480x320',
      '320x480',
      '300x250'
      ];

    this.endGameTypes =	[
      {name: 'Static', value: 'static'},
      {name: '480x320 MRAID Banner', value:'480x320 MRAID Banner', dimensions: {w: 480, h: 320}, type: 'mraid_banner'},
      {name: '320x480 MRAID Banner', value:'320x480 MRAID Banner', dimensions: {w: 320, h: 480}, type: 'mraid_banner'},
      {name: '768x1024 MRAID Banner', value:'768x1024 MRAID Banner', dimensions: {w: 768, h: 1024}, type: 'mraid_banner'},
      {name: '1024x768 MRAID Banner', value:'1024x768 MRAID Banner', dimensions: {w: 1024, h: 768}, type: 'mraid_banner'},
      {name: '480x320 Dynamic MRAID Banner', value:'480x320 Dynamic MRAID Banner', dimensions: {w: 480, h: 320}, type: 'mraid_dynamic'},
      {name: '320x480 Dynamic MRAID Banner', value:'320x480 Dynamic MRAID Banner', dimensions: {w: 320, h: 480}, type: 'mraid_dynamic'},
      {name: '768x1024 Dynamic MRAID Banner', value:'768x1024 Dynamic MRAID Banner', dimensions: {w: 768, h: 1024}, type: 'mraid_dynamic'},
      {name: '1024x768 Dynamic MRAID Banner', value:'1024x768 Dynamic MRAID Banner', dimensions: {w: 1024, h: 768}, type: 'mraid_dynamic'},
    ];

    this.mraidApiFrameworks =	[
      {name: 'MRAID-1', value: 3},
      {name: 'MRAID-2', value: 5},
      {name: 'MRAID-3', value: 6}
    ];

    this.mraidCompanions = _.filter(this.creative.companion_ads, ca => ca.companion_ad_type === 'mraid_banner' || ca.companion_ad_type === 'mraid_dynamic') || {};
    this.endGameType = 'static';

    this.mainVideoSafeUrl =
          this.$sce.trustAsResourceUrl(this.videoAdMainVideoUrl);

    this.thumbnailImageSafeUrl =
        this.$sce.trustAsResourceUrl(this.videoAdThumbnailImageUrl);

    if (!this.creative.companionAdsMap) {
      this.creative.companionAdsMap = {};
    }

    if(!this.creative.id) {
      this.creative.active = true;
    }

    $scope.$on('scrollToCreative', (event, creativeId) => {
      if (!this.creative || String(this.creative.id) === String(creativeId)) return;
      const tryOpen = () => {
        const companionAd = _.find(_.values(this.creative.companionAdsMap), ca => ca && String(ca.id) === String(creativeId));
        if (companionAd) {
          $timeout(() => {
            const el = $element[0];
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.classList.add('is-highlighted');
            $timeout(() => el.classList.remove('is-highlighted'), 2000);
            this.isEditingCompanionAds = true;
            if (companionAd.url) {
              this.openAdEndCardPreview(companionAd.url, companionAd.id);
            }
          }, 300);
        }
      };
      if (!this.isCompanionAdsLoaded && this.creative.id) {
        this.GamesResource.one(this.$stateParams.gameId)
          .one('variations', this.creative.variation_id)
          .one('creatives', this.creative.id)
          .getList('companion-ads')
          .then((result) => {
            this.creative.companionAdsMap = this.getDeserialisedCompanionAdsMap(result);
            this.isCompanionAdsLoaded = true;
            tryOpen();
          });
      } else {
        tryOpen();
      }
    });
  }

  buildDeepLink(companionAdId) {
    const variationId = this.variation && this.variation.id;
    if (!variationId || !companionAdId) return null;
    const baseUrl = this.$window.location.href.replace(/#\d+(-\d+)?$/, '');
    return baseUrl + '#' + variationId + '-' + companionAdId;
  }

  updateUrlWithCreativeId(companionAdId) {
    const deepLink = this.buildDeepLink(companionAdId);
    if (deepLink) {
      this.$window.history.replaceState(null, '', deepLink);
    }
  }

  removeCreativeIdFromUrl() {
    const cleanedUrl = this.$window.location.href.replace(/-\d+$/, '');
    this.$window.history.replaceState(null, '', cleanedUrl);
  }

  showPreviewModal(res, width, height){
    return this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <iframe ng-src="{{vm.res}}" style='margin-top: 75px;' width="{{vm.width}}" height="{{vm.height}}" frameborder='0'"/>
            <svg gg-icon='icon-close' style='position: absolute; margin-top: 50px;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.res = res;
        this.width = width;
        this.height = height;
        this.close = close;
      }
    });
  }

  openMraidPreview(mraidCompanion){
    this.updateUrlWithCreativeId(mraidCompanion.id);
    let [width, height] = (mraidCompanion.size || '750x650').split('x').map(v => parseInt(v, '10'));
    let mraidPreviewUrl = this.$sce.trustAsResourceUrl("https://bidder.dsp.youappi.com/creative/preview/" + this.creative.id + "/" + mraidCompanion.id);
    this.showPreviewModal(mraidPreviewUrl, width, height).then((modal) => modal.closed.then(() => this.removeCreativeIdFromUrl()));
  }

  fetchCompanionAds() {
      this.GamesResource.one(this.$stateParams.gameId)
      .one('variations', this.creative.variation_id)
      .one('creatives', this.creative.id)
      .getList('companion-ads')
      .then((companionAdsResult) => {
        this.creative.companionAdsMap = this.getDeserialisedCompanionAdsMap(companionAdsResult);
      });
  }

  showCompanionAds() {
    if (!this.isCompanionAdsLoaded) {
      this.fetchCompanionAds();
      this.isCompanionAdsLoaded = true;
    }
    this.isEditingCompanionAds = !this.isEditingCompanionAds;
  }

  removeMraidCompanionAd(type,size) {
    this.creative.companionAdsMap[`${type}_${size}`].is_deleted = true;
    const selectedCreative = _.find(this.variation.creatives, c => c.id === this.creative.id);
    selectedCreative.companionAdsMap[`${type}_${size}`].is_deleted = true;
    const companionAdId = selectedCreative.companionAdsMap[`${type}_${size}`].id;
    const selectedCompanionAd = _.find(selectedCreative.companion_ads, ca => ca.id === companionAdId);
    selectedCompanionAd.is_deleted = true;
    this.GamesResource
        .one(this.$stateParams.gameId)
        .one('variations', this.creative.variation_id)
        .one('creatives', this.creative.id)
        .one('companion-ads', this.creative.companionAdsMap[`${type}_${size}`].id)
        .customPUT(this.creative.companionAdsMap[`${type}_${size}`])
        .then((res) => {
          this.creative.companionAdsMap[`${type}_${size}`] = {};
          this.mraidCompanions = _.filter(this.mraidCompanions, mc => mc.size !== size);
        })
  }

  removeCompanionAd(size) {
    this.creative.companionAdsMap[size].is_deleted = true;
    const selectedCreative = _.find(this.variation.creatives, c => c.id === this.creative.id);
    selectedCreative.companionAdsMap[size].is_deleted = true;
    const companionAdId = selectedCreative.companionAdsMap[size].id;
    const selectedCompanionAd = _.find(selectedCreative.companion_ads, ca => ca.id === companionAdId);
    selectedCompanionAd.is_deleted = true;

    this.GamesResource
        .one(this.$stateParams.gameId)
        .one('variations', this.creative.variation_id)
        .one('creatives', this.creative.id)
        .one('companion-ads', this.creative.companionAdsMap[size].id)
        .customPUT(this.creative.companionAdsMap[size])
        .then((res) => {
          this.creative.companionAdsMap[size] = {}
        })
  }

  removeCreative() {
    if (!this.creative.id) {
      let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.type == this.creative.type;});
      if (indexOfCreativeToRemove > -1) {
        this.variation.creatives.splice(indexOfCreativeToRemove,1);
      }
    } else {
      this.creative.is_deleted = true;

      _.forEach(this.creative.companion_ads, (c, key) => {
        c.is_deleted = true;
      });

      return this.GamesResource.one(this.$stateParams.gameId).one('variations', this.creative.variation_id).one('creatives', this.creative.id).customPUT(this.creative)
          .then((creativeRes) => {
            let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.id == this.creative.id;});
            if (indexOfCreativeToRemove > -1) {
              this.variation.creatives.splice(indexOfCreativeToRemove,1);
            }
          });
    }
  }

  get creatives() {
    return _.chain(this.variation).map('creatives').flatten().value();
  }

  get companionAdsIds() {
    const ids = _.compact(_.map(_.values(this.creative.companionAdsMap), v => v.id));
    return (_.isEmpty(ids) || ids.length > 1) ? '' : `(${_.map(ids, v => `#${v}`).join(', ')})`;
  }

  get companionAd1024x768Url() {
    return _.get(this.creative.companionAdsMap, '_1024x768.url') || _.get(this.creative.companionAdsMap, '_1024x768.file.$ngfBlobUrl');
  }

  get companionAd768x1024Url() {
    return _.get(this.creative.companionAdsMap, '_768x1024.url') || _.get(this.creative.companionAdsMap, '_768x1024.file.$ngfBlobUrl');
  }

  get companionAd480x320Url() {
    return _.get(this.creative.companionAdsMap, '_480x320.url') || _.get(this.creative.companionAdsMap, '_480x320.file.$ngfBlobUrl');
  }

  get companionAd320x480Url() {
    return _.get(this.creative.companionAdsMap, '_320x480.url') || _.get(this.creative.companionAdsMap, '_320x480.file.$ngfBlobUrl');
  }

  get companionAd300x250Url() {
    return _.get(this.creative.companionAdsMap, '_300x250.url') || _.get(this.creative.companionAdsMap, '_300x250.file.$ngfBlobUrl');
  }

  get companionAd1024x768Id() {
    return _.get(this.creative.companionAdsMap, '_1024x768.id') || '';
  }

  get companionAd768x1024Id() {
    return _.get(this.creative.companionAdsMap, '_768x1024.id') || '';
  }

  get companionAd480x320Id() {
    return _.get(this.creative.companionAdsMap, '_480x320.id') || '';
  }

  get companionAd320x480Id() {
    return _.get(this.creative.companionAdsMap, '_320x480.id') || '';
  }

  get companionAd300x250Id() {
    return _.get(this.creative.companionAdsMap, '_300x250.id') || '';
  }

  handleNewMRaidCompanionFile(mraidCompanionFile, type){
    const selectedEngGameInfo = _.find(this.endGameTypes, e => e.value === type)
    let dimensionsString = selectedEngGameInfo.dimensions.w + 'x' + selectedEngGameInfo.dimensions.h;
    let key = selectedEngGameInfo.type+'_'+dimensionsString;
    if (!(key in this.creative.companionAdsMap)) {
      this.creative.companionAdsMap[key] = {};
    }
    this.creative.companionAdsMap[key].url = null;
    this.creative.companionAdsMap[key].file = mraidCompanionFile;
    this.creative.companionAdsMap[key].size = dimensionsString;
    this.creative.companionAdsMap[key].media_type = mraidCompanionFile.type;
    this.creative.companionAdsMap[key].companion_ad_type = selectedEngGameInfo.type;
    this.creative.companionAdsMap[key].api_framework = this.companionMraidApiFrameworkValue;
    this.creative.companionAdsMap[key].num_products = this.companionMraidNumProductsValue;
  }

  onExistingMraidApiFramworkChange(mraidCompanion) {
    this.creative.companionAdsMap[mraidCompanion.companion_ad_type+'_'+mraidCompanion.size].api_framework = mraidCompanion.api_framework;
  }

  onExistingMraidDefinitionChange(mraidCompanion) {
    this.creative.companionAdsMap[mraidCompanion.companion_ad_type+'_'+mraidCompanion.size].definition = mraidCompanion.definition;
  }

  onExistingMraidNumProductsChange(mraidCompanion) {
    this.creative.companionAdsMap[mraidCompanion.companion_ad_type+'_'+mraidCompanion.size].num_products = mraidCompanion.num_products;
  }

  onMraidApiFramworkChange(value) {
    const selectedEngGameInfo = _.find(this.endGameTypes, e => e.value === this.endGameType)
    let dimensionsString = selectedEngGameInfo.dimensions.w + 'x' + selectedEngGameInfo.dimensions.h;
    let key = selectedEngGameInfo.type+'_'+dimensionsString;

    if (!(key in this.creative.companionAdsMap)) {
      this.creative.companionAdsMap[key] = {};
    }
    this.creative.companionAdsMap[key].api_framework = value;

  }

  onCompanionMraidNumProductsValueChange(type) {
    const selectedEngGameInfo = _.find(this.endGameTypes, e => e.value === type)
    let dimensionsString = selectedEngGameInfo.dimensions.w + 'x' + selectedEngGameInfo.dimensions.h;
    let key = selectedEngGameInfo.type+'_'+dimensionsString;

    if (!(key in this.creative.companionAdsMap)) {
      this.creative.companionAdsMap[key] = {};
    }
    this.creative.companionAdsMap[key].num_products = this.companionMraidNumProductsValue;
  }

  handleNewCompanionAd(image) {
    if(image) {
      if(_.indexOf(this.validFileTypes, image.type) > -1) {
        this.Upload.imageDimensions(image).then((dimensions) => {
          let dimensionsString = dimensions.width + 'x' + dimensions.height;
          if(_.intersection(this.allowedCompanionAdSizes, [dimensionsString]).length > 0){
            let key = '_'+dimensionsString;
            if (!(key in this.creative.companionAdsMap)) {
              this.creative.companionAdsMap[key] = {};
            }
            this.creative.companionAdsMap[key].url = null;
            this.creative.companionAdsMap[key].file = image;
            this.creative.companionAdsMap[key].size = dimensionsString;
            this.creative.companionAdsMap[key].media_type = image.type;
            this.creative.companionAdsMap[key].companion_ad_type = 'banner';
          } else {
            this.notify.warning('dimensionInvalidExpected', {dimension: dimensionsString, expected: '1024x768/768x1024/480x320/320x480'});
          }
        });
      } else {
        this.notify.warning('fileTypeInvalid', {type: image.type});
      }
    }
  }

  handleVideoMetadata(thumbVideoPlayer){
      thumbVideoPlayer.addEventListener('canplay', function() {
          this.currentTime = 1;
      });
    }

  handleNewMainVideo(mainVideo){
    this.isLoadingMainVideo = true;
    if (mainVideo){

      var thumbVideoPlayer = document.getElementById('thumb_video_player');
        thumbVideoPlayer.addEventListener('loadedmetadata', this.handleVideoMetadata.bind(this, thumbVideoPlayer));

      this.mainVideoSafeUrl =
        this.$sce.trustAsResourceUrl((window.URL || window.webkitURL).createObjectURL(mainVideo));

      this.$scope.$emit('newFileUploaded', mainVideo, this.creative, 'mainVideo');
      this.setProgressBar(this, 1, 1).then(() => this.isLoadingMainVideo = false);
    }
  }

  get videoAdMainVideoUrl() {
    return this.creative.url || _.get(this.creative, 'mainVideo')
  }

  get videoAdThumbnailImageUrl() {
    return this.creative.thumbnail_image_url;
  }

  openAdMainVideoPreview(){
      this.showVideoPreviewModal(this.mainVideoSafeUrl);
  }

  showVideoPreviewModal(url){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++" style='position: relative;'>
            <video ng-src="{{vm.url}}" controls width='600px' ng-click="$event.stopPropagation()" style='margin-top: 15px;'/>
            <svg gg-icon='icon-close' style='position: absolute;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  openAdEndCardPreview(url, companionAdId) {
    if (companionAdId) {
      this.updateUrlWithCreativeId(companionAdId);
    }
    this.showPreviewModalUrlOnly(url).then((modal) => modal.closed.then(() => this.removeCreativeIdFromUrl()));
  }

  showPreviewModalUrlOnly(url){
    return this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <img ng-src="{{vm.url | adaptNonCDNHttpsUrls}}" style='margin-top: 15px;'/>
            <svg gg-icon='icon-close' style='position: absolute;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  getDeserialisedCompanionAdsMap(companionAds) {
    let companionAdMapBuilder = {};
    _.forEach(companionAds, (companionAd) => {
      if (companionAd.companion_ad_type === 'banner') {
        companionAdMapBuilder['_'+companionAd.size] = companionAd;
      } else if (companionAd.companion_ad_type === 'mraid_banner') {
        companionAdMapBuilder['mraid_banner_'+companionAd.size] = companionAd;
      } else if (companionAd.companion_ad_type === 'mraid_dynamic') {
        companionAdMapBuilder['mraid_dynamic_'+companionAd.size] = companionAd;
      }
    });

    _.forEach(this.allowedCompanionAdSizes, (allowedCompanionAdSize) => {
      if(!companionAdMapBuilder['_'+allowedCompanionAdSize]) {
        companionAdMapBuilder['_'+allowedCompanionAdSize] = {};
      }
    });

    return companionAdMapBuilder;
  }

  getSerializeCompanionAds() {
    let creativeId = this.creative.id;
    var arrayWithAllProperties = [];

    _.forEach(this.creative.companionAdsMap, (companionAd) => {
      arrayWithAllProperties.push({
        id: companionAd.id,
        size: companionAd.size,
        url: companionAd.url,
        s3_url: companionAd.s3_url,
        media_creative_id: creativeId
      });
    });

    return _.map(arrayWithAllProperties, (obj) => {
      return _.pick(obj, ['id', 'size', 'url', 's3_url', 'media_creative_id']);
    });
  }

}

let VideoCreativesFormComponent = {
  template: () => { return template },
  controller: VideoCreativesFormController,
  controllerAs: 'vm',
  bindings: {
    creative: '=',
    variation: '=',
    disableField: '='
  }
};

export default angular.module('app.components.campaigns.videoCreativesForm', [
  ConfigsModule.name,
  ServicesModule.name,
  Filters.name,
  FiltersModule.name,
  'angularModalService'
])
  .component('videoCreativesForm', VideoCreativesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/videoCreativesForm.js
 **/